<template>
  <div class="preview">
    <!-- 抬头 -->
    <div class="preview-head">
      <img src="../../../assets/image/questionnaires/组 631.png">
    </div>
    <!-- 内容区域 -->
    <div class="preview-contents">
      <div class="preview-contents-box">
        <!-- 标题 -->
        <div class="preview-contents-box-head">
          <h4 class="preview-contents-box-head-h4">
            {{form.survey_name}}</h4>
        </div>
        <!-- 内容区域-->
        <div class="preview-contents-box-contents">
          <div class="container">
            <el-form
              ref="form"
              :model="form"
            >
              <!-- 遍历已创建的选项渲染 -->
              <div
                class="item"
                v-for="(item, index) in form.survey_description"
                :key="index"
              >
                <el-form-item :label="(index+1)+''">
                  <div class="item_title">
                    <span v-text="item.question_name"></span>
                  </div>
                  <!-- 单项填空 -->
                  <div v-if="item.question_type==='input'">
                    <el-input
                      style="width:50%;"
                      class="disabled"
                      placeholder="请输入信息"
                      v-model="item.answer"
                      @input="orderNoChange"
                    ></el-input>
                  </div>
                  <!-- 手机验证 -->
                  <div v-else-if="item.question_type==='phoneValidation'">
                    <div>
                      <!-- 第一排 -->
                      <div style="display:flex;">
                        <span class="matrix-left-poh">手机号</span>
                        <el-input
                          style="width:685px;"
                          @input="orderNoChange"
                          placeholder="请输入手机号"
                          v-model="item.answer[0]"
                        ></el-input>
                      </div>
                      <!-- 第一排 结束-->
                      <!-- 第二排 -->
                      <div style="display:flex; margin-top:20px;">
                        <span class="matrix-left-poh">验证码</span>
                        <el-input
                          style="width:550px;"
                          @input="orderNoChange"
                          placeholder="请输入验证码"
                          v-model="item.answer[1]"
                        ></el-input>
                        <!-- <get-code
                          style="margin-left:20px;"
                          :ruleForm="ruleForm"
                          :type="'CURRENCY'"
                        /> -->
                        <el-button
                          disabled
                          style="background: #484c7f; color: #fff; margin-left:20px;"
                        >获取验证码
                        </el-button>
                      </div>
                      <!-- 第二排 结束-->
                    </div>
                  </div>
                  <!-- 城市选择 -->
                  <div v-else-if="item.question_type==='cascader'">
                    <el-cascader
                      style="width:36.5%;"
                      v-model="item.answer"
                      :options="cityList"
                    >
                    </el-cascader>
                  </div>
                  <!-- 单选 -->
                  <div
                    class="horizontal"
                    v-else-if="item.question_type==='radio'"
                  >
                    <div
                      class="warp"
                      v-for="(elm, i) in item.options"
                      :key="i"
                    >
                      <el-radio-group v-model.trim="item.answer">
                        <el-radio :label="elm.id">
                          {{elm.option_name}}
                        </el-radio>
                      </el-radio-group>

                      <div
                        v-if="elm.is_fill==1 && item.answer==elm.id"
                        class="beizhu"
                      >
                        <el-input
                          placeholder="请输入内容"
                          v-model="elm.value"
                        ></el-input>
                      </div>

                    </div>
                  </div>
                  <!-- 多选 -->
                  <div
                    class="horizontal"
                    v-else-if="item.question_type==='checkbox'"
                  >
                    <div
                      class="warp"
                      v-for="(elm, i) in item.options"
                      :key="i"
                    >
                      <el-checkbox
                        v-model="item.answer"
                        :label="elm.id"
                      >{{elm.option_name}}
                      </el-checkbox>
                      <div
                        v-if="elm.is_fill==1 && item.answer.indexOf(elm.id)!=-1"
                        class="beizhu"
                      >
                        <el-input
                          placeholder="请输入内容"
                          v-model="elm.value"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                  <!-- 下拉选择 -->
                  <div v-else-if="item.question_type === 'select'">
                    <el-select
                      v-model="item.answer"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(elm, i) in item.options"
                        :key="i"
                        :label="elm.option_name"
                        :value="elm.option_name"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <!-- 矩阵填空 -->
                  <div v-else-if="item.question_type==='matrix'">
                    <div
                      class="matrix"
                      v-for="(elm, i) in item.options"
                      :key="i"
                    >
                      <div class="matrix-left"> {{elm.option_name}}</div>
                      <el-input
                        style="width:685px;"
                        v-model="item.answer[i]"
                        class="disabled"
                        placeholder="请输入信息"
                        @input="orderNoChange"
                      ></el-input>
                    </div>
                  </div>
                  <!-- 富文本 -->
                  <div
                    v-if="item.question_type==='paragraph'"
                    class="fuwenben"
                    v-html="item.question_name"
                  ></div>
                  <!-- 上传文件 -->
                  <div v-if="item.question_type==='upload'">
                    <!-- :before-remove="beforeRemove" -->
                    <el-upload
                      v-model="item.answer"
                      class="upload-demo"
                      :action="action"
                      :on-preview="handlePreview"
                      :on-remove="(file, fileList) => {
                      return handleRemove(file, fileList, index)}"
                      :on-success="(response, file, fileList) => {
                      return handleAvatarSuccess(response, file, fileList, index)}"
                      multiple
                      :limit="10"
                      :on-exceed="handleExceed"
                      :file-list="fileList"
                      :data="uploadData"
                      :before-upload="wenBeforeUpload"
                      :on-progress="onProgressTest"
                    >
                      <el-button
                        size="small"
                        type="primary"
                      >点击上传</el-button>
                      <div
                        slot="tip"
                        class="el-upload__tip inage-form-item-warn"
                      >可上传多个PPT、PDF、图片等格式文件（最大上限50M，文件名称请勿添加 "," ）</div>
                    </el-upload>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <!-- 关闭预览 -->
          <div class="close-preview">
            <el-button
              type="primary"
              @click="closePreview"
              style="background: #484c7f; color: #fff;"
            >关闭预览</el-button>
          </div>
        </div>
        <!-- 内容区域 结束-->
      </div>
      <!-- 底部 -->
      <div class="preview-bottom">
        <div class="contents-right-ending-log">
          <img src="../../../assets/image/questionnaires/共识云logo长方.png">
        </div>
        <div class="contents-right-ending-text">您已完成本次问卷，感谢您的帮助与支持</div>
      </div>
    </div>
    <!-- 底部 结束 -->
  </div>
  </div>
</template>  
 
<script> 
import city from "../../../utils/city";
import getCode from '../../../components/getCode/index.vue'
export default {
  name: 'preview',
  components: {
    getCode
  },
  data () {
    return {
      ruleForm: {},
      cityList: [],
      value: '',
      form: {
        // survey_name: '明朝那些事',
        // survey_detail: [
        //   //1 id:每一条的id  question_type:类型  question_name:标题 options:选项  name:选中某一项  ,options如果没有 直接给一个空数组 
        //   //单框输入 
        //   { id: '', question_type: 'input', question_name: '姓名', answer: "", options: [] },
        //   //城市选择器
        //   {
        //     id: '', question_type: 'cascader', question_name: '请选择城市', answer: ['110000', '110100', '110101'], options: []
        //   },
        //   //手机验证 
        //   {
        //     id: '', question_type: 'phoneValidation', question_name: '手机验证', answer: [], options: [{ option_name: '手机号' }, { option_name: '验证码' }]
        //   },
        //   //单选
        //   {
        //     id: '', question_type: 'radio', question_name: '性别', options: [{ option_name: '女' }, { option_name: '男' },
        //     { option_name: '人妖' }], answer: "人妖"
        //   },
        //   //多选   
        //   {
        //     id: '', question_type: 'checkbox', question_name: '明朝皇帝', options: [{ option_name: '朱元璋' }, { option_name: '朱棣' },
        //     { option_name: '朱祁镇' }], answer: ['朱棣']
        //   },
        //   //下拉  '朱元璋', '朱棣', '朱瞻基'
        //   {
        //     id: '', question_type: 'select', question_name: '你最喜欢哪位皇帝',
        //     options: [{ option_name: '朱元璋' }, { option_name: '朱棣' }, { option_name: '朱瞻基' }], answer: "朱棣"
        //   },
        //   //多框输入 
        //   {
        //     id: '', question_type: 'matrix', question_name: '个人信息', 
        //     options: [{ option_name: '家住哪里' }, { option_name: '家里几口' }, { option_name: '人均几口地' }],
        //     answer: ['家住小河湾', '100口', '1000亩']
        //   },
        // ] 
      },
    }
  },
  created () {
    this.cityList = city.city
    this.form = JSON.parse(this.$route.query.form)
  },
  methods: {
    orderNoChange () {
      this.$forceUpdate();
    },
    //关闭预览
    closePreview () {
      this.$router.push('/questionnaires/create')
    },
  }
}

</script> 
<style lang="less" scoped>
.preview {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .preview-head {
    position: relative;
    width: 100%;
    height: 549px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .preview-contents {
    width: 85%;
    position: relative;
    top: -90px;
    left: 0;

    .preview-contents-box {
      width: 100%;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px #d0d3fb;
      border-top-left-radius: 60px;
      border-top-right-radius: 60px;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;

      .preview-contents-box-head {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 43px 0 95px 0;
        .preview-contents-box-head-h4 {
          font-size: 18px;
          color: #484c7f;
        }
      }
      .preview-contents-box-contents {
        // padding: 0 515px 0 238px;
        // padding: 0 50px 50px 50px;
        // padding: 0 400px 50px 400px;
        padding: 0 50px 50px 80px;

        .item {
          margin-bottom: 40px;
        }
        .warp {
          display: flex;
          align-items: center;
          margin-bottom: 5px;
        }
        .matrix {
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          .matrix-left {
            width: 100px;
            text-align: right;
            margin-right: 25px;
          }
        }
        .matrix-left-poh {
          width: 45px;
          text-align: right;
          margin-right: 25px;
        }
        .horizontal {
          // display: flex;
        }

        /deep/ .el-radio {
          line-height: 40px;
          margin-right: 30px;
        }

        /deep/ .el-checkbox {
          line-height: 40px;
          margin-right: 30px;
        }

        /deep/ .el-form-item__label {
          position: relative;
          z-index: 1;
          margin-right: 13px;
          color: #fff;

          &::before {
            content: "";
            z-index: -1;
            position: absolute;
            top: 7px;
            left: -11px;
            width: 34px;
            height: 28px;
            background: url("../../../assets/image/questionnaires/组 600.png")
              no-repeat;
          }
        }
        /deep/ .item_title {
          margin-bottom: 15px;
        }
      }
    }

    .close-preview {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 50px;
    }
  }

  .preview-bottom {
    margin-left: 50px;
    padding: 66px 0 58px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .contents-right-ending-log {
      width: 128px;
      height: 36px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .contents-right-ending-text {
      margin-top: 19px;
      color: #484c7f;
      font-size: 16px;
    }
  }

  .upload-demo {
    // width: 80% !important;
  }
  .el-upload__tip {
    color: red;
  }

  .beizhu {
    width: 60%;

    /deep/ .el-input__inner {
      border-radius: 0 !important;
      border-top: 0 !important;
      border-left: 0 !important;
      border-right: 0 !important;
      border: 1px solid #dcdfe6;
    }
  }

  .fuwenben {
    margin-top: 26px;
  }
}
</style>   